import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import '@/assets/styles/index.scss' // global css

import './assets/icons' // icon
import {
  getUserInfo,
  setTMap
} from '@/utils/tool';

import CustomForm from '@/components/customForm'
import CustomDescriptions from '@/components/customDescriptions'
import elImageCustom from '@/components/elImageCustom/main';

Vue.use(ElementUI);
Vue.config.productionTip = false

//挂载分页数据列表
Vue.prototype.$pageSizeList = [10, 20, 30, 40, 50, 80, 100, 200, 500];

//挂载全局登录用户信息
Vue.prototype.$globalInfo = () => {
  let userInfo = getUserInfo();
  return {
    userName: userInfo.name,
    userId: userInfo.user_id,
    token: userInfo.token
  }
}

//挂载全局loading方法
Vue.prototype.$setLoading = (text = 'Loading') => {
  let loading = Vue.prototype.$loading({
      lock: true,
      text: text,
      spinner: 'el-icon-loading',
      background: 'rgba(0, 0, 0, 0.7)'
  });
  return loading;
}

// 全局组件挂载
Vue.component('CustomForm', CustomForm)
Vue.component('CustomDescriptions', CustomDescriptions)
Vue.component('elImageCustom', elImageCustom)


// new Vue({
//   router,
//   store,
//   render: h => h(App)
// }).$mount('#app')

setTMap();

async function init() {
  await store.dispatch('user/setGlobalConfig');
  new Vue({
    router,
    store,
    render: h => h(App)
  }).$mount('#app')
}

init();